<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-card
          v-for="(item, i) in categories"
          :key="i"
          class="mt-2 rounded-lg d-flex pa-4 align-center"
          @click="
            () => {
              dialog = true;
              tabs = i;
            }
          "
        >
          <div>
            <v-avatar class="me-2" size="48">
              <img
                :alt="item.name"
                :src="item.picture"
                style="object-fit: contain"
                width="48px"
              />
            </v-avatar>
            دسته‌بندی
            <v-btn class="ms-1" outlined>{{ item.name }}</v-btn>
          </div>

          <v-spacer />
          <v-btn icon max-width="36" @click.stop="deleteCat(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-icon>mdi-cursor-default-click-outline</v-icon>
        </v-card>

        <custom-popup
          v-model="dialog"
          :cons="{ title: 'ویرایش دسته‌بندی‌های نوبت‌دهی' }"
          :hide-confirm="innerTabs === 1"
          hide-close
        >
          <div class="pt-2">
            <v-tabs v-model="tabs">
              <v-tab v-for="(tab, i) in categories" :key="i">
                <v-avatar class="me-2" size="32">
                  <img
                    :alt="tab.name"
                    :src="tab.picture"
                    style="object-fit: contain"
                  />
                </v-avatar>
                {{ tab.name }}
              </v-tab>

              <v-tab-item v-for="(tab, i) in categories" :key="i">
                <div class="pa-2">
                  <custom-tabs
                    v-model="innerTabs"
                    :tab-items="innerTabItems"
                    grow
                  >
                    <template v-slot:helpinfo="{ tab }">
                      <help-info
                        v-if="tab && tab.value && tab.text"
                        :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="`${tab.text}`"
                      />
                    </template>
                    <template v-slot:staticItems>
                      <v-tab-item class="pa-2">
                        <rec-appointments
                          v-if="tabs === i"
                          :value="tab"
                          only-appointments
                          @input="computedCategory = $event"
                        />
                      </v-tab-item>

                      <v-tab-item class="pa-md-4">
                        <v-row v-if="tempCategory" no-gutters>
                          <v-col cols="12" md="6">
                            <div class="rowinfo">
                              <v-text-field
                                v-model="tempCategory.name"
                                class="rounded-lg contentinfo"
                                clearable
                                dense
                                hide-details
                                label="نام دسته‌بندی"
                                outlined
                              />
                              <help-info
                                :element-name="`${serviceName}-${componentName}-tempCategory-name-edit`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                label="نام دسته‌بندی"
                              />
                            </div>

                            <pic-selector
                              :edit-name="false"
                              :field.sync="tempCategory.picture"
                              one-pic
                              single
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-card-actions>
                              <div class="rowinfo" :disabled="!canEdit">
                                <v-btn
                                  :disabled="!canEdit"
                                  class="btn-edit ma-0 rounded-lg contentinfo"
                                  @click="updateCat"
                                >
                                  <v-icon>mdi-pencil</v-icon>
                                  ذخیره ویرایش
                                </v-btn>
                                <help-info
                                  @update:helpData="
                                    (newData) => updateData(newData)
                                  "
                                  :element-name="`${serviceName}-${componentName}-update-category`"
                                  :service-name="serviceName"
                                  :help-data="helpData"
                                  class="buttoninfo"
                                  label=" ذخیره ویرایش"
                                />
                              </div>
                            </v-card-actions>
                          </v-col>
                        </v-row>
                      </v-tab-item>
                    </template>
                  </custom-tabs>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import Appointments from "@/view/pages/otherQrTypes/appointment/cm/Appointments.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";

export default {
  name: "editAppointmentCategory",

  components: {
    PicSelector,
    "rec-appointments": Appointments,
  },

  props: {
    value: Object,
    categories: Array,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "edit-appointment-category",
    dialog: false,
    tabs: 0,
    innerTabs: 0,
    tempCategory: null,
  }),

  computed: {
    innerTabItems() {
      return [
        { text: "نوبت‌ها", icon: "ticket-account", value: "ticket-account" },
        { text: "ویرایش دسته‌بندی", icon: "pencil", value: "edit" },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedCategory: {
      get() {
        return this.categories;
      },
      set(val) {
        this.$emit("update:categories", val);
      },
    },
    canEdit() {
      return !(
        this.categories[this.tabs].name === this.tempCategory?.name &&
        this.categories[this.tabs].picture === this.tempCategory?.picture
      );
    },
  },

  watch: {
    innerTabs(val) {
      this.tempCategory = !!val ? { ...this.categories[this.tabs] } : null;
      this.$forceUpdate();
    },
  },

  methods: {
    async deleteCat(item) {
      if (await this.$modal.yesNo(`حذف دسته‌بندی ${item.name}؟`)) {
        this.$api
          .delete("/v1/testQr/category-reservation/delete", {
            params: {
              id: item.id,
            },
          })
          .then(({ data }) => {
            this.$toast.success("دسته‌بندی با موفقیت حذف شد");
            this.$emit("fetch");
          })
          .catch(({ response }) =>
            console.log("failed to delete reservation category: ", response),
          );
      }
    },
    updateCat() {
      this.loading = true;

      this.$api
        .post("/v1/testQr/category-reservation", this.tempCategory)
        .then(({ data }) => {
          try {
            const obj = { ...this.tempCategory };
            this.computedCategory[this.tabs] = obj;
            this.$toast.success("دسته‌بندی با موفقیت ایجاد شد.");
            this.tempCategory = null;
            this.$nextTick(() => {
              this.tempCategory = { ...obj };
            });
          } catch (e) {
            console.log(e);
          }
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در ویرایش دسته‌بندی!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>
